import Fieldset from './Fieldset';
import type { FieldsetProps } from './Fieldset';

export type { FieldsetProps };
export default Fieldset;
